import { useContext } from "react";
import { AppUAContext } from "@/context/uaContext";

export const useTrack = () => {
  const TrackCustomEvents = {
    EVENT_BROWSED: "browsed-web",
    EVENT_SEARCHED: "searched-web",
    EVENT_PURCHASED: "purchased-web",
    EVENT_REGISTERED_ACCOUNT: "registered_account-web",
    EVENT_ADD_TO_WISHLIST: "add_to_wishlist-web",
    EVENT_ADD_PAYMENT_INFO: "add_payment_info-web",
    EVENT_SHARED_PRODUCT: "shared_product-web",
    EVENT_FIRST_REGION_CHOSEN: "first_region_chosen-web",
    EVENT_FIRST_CATEGORIES_CHOSEN: "first_categories_chosen-web",
    EVENT_ACTIVE_REGION: "community_city",
    EVENT_ACTIVE_CATEGORIES: "active_categories-web",
    EVENT_BROWSED_WEB: "browsed",
    EVENT_CHECKOUT_WEB: "reservation-checkout-web",
    EVENT_SEARCHED_WEB: "searched",
    EVENT_PURCHASED_WEB: "purchased",
    EVENT_REGISTERED_ACCOUNT_WEB: "registered_account",
    EVENT_ADD_TO_WISHLIST_WEB: "add_to_wishlist",
    EVENT_ADD_PAYMENT_INFO_WEB: "add_payment_info",
    EVENT_SHARED_PRODUCT_WEB: "shared_product",
    EVENT_FIRST_REGION_CHOSEN_WEB: "first_region_chosen",
    EVENT_FIRST_CATEGORIES_CHOSEN_WEB: "first_categories_chosen",
    EVENT_ACTIVE_REGION_WEB: "community_city",
    EVENT_ACTIVE_CATEGORIES_WEB: "active_categories",
  };

  const { sdkState } = useContext(AppUAContext);

  const trackEvent = (event: {
    name: string;
    value?: string | number;
    properties: object;
  }) => {
    if (sdkState) {
      //@ts-ignore
      const myEvent = new sdkState.CustomEvent(event.name);
      myEvent.value = event.value;
      myEvent.properties = event.properties;
      myEvent.track().catch((err: any) => {
        // see validate() below
        console.log("error"), err;
      });
    }
  };

  return {
    trackEvent,
    TrackCustomEvents,
  };
};
